// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N6A5","left":"styles_left__dnSPu"};